export const MUTATE_SET_IMAGEDATA = 'MUTATE_SET_IMAGEDATA';
export const MUTATE_UPDATE_IMAGEDATA = 'MUTATE_UPDATE_IMAGEDATA';
export const MUTATE_SET_IMAGE_PATH = 'MUTATE_SET_IMAGE_PATH';
export const MUTATE_ADD_DETAILS = 'MUTATE_ADD_DETAILS';

export const SET_IMAGEDATA = 'SET_IMAGEDATA';
export const UPDATE_IMAGEDATA = 'UPDATE_IMAGEDATA';
export const SET_IMAGE_PATH = 'SET_IMAGE_PATH';
export const ADD_DETAILS = 'ADD_DETAILS';